var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForward({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-2.4 -2.4 28.80 28.80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#000000",
    strokeWidth: 0.072,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("rect", {
    x: -2.4,
    y: -2.4,
    width: 28.8,
    height: 28.8,
    rx: 0,
    fill: "#ffffff",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6 3.80353C16.4468 2.26658 14 3.08182 14 5.00302V8.00929C9.32281 7.86093 6.22286 9.50672 4.22042 11.7657C2.13865 14.1142 1.33668 17.0185 1.02193 18.9028C0.884035 19.7283 1.41941 20.3237 1.98513 20.5275C2.52889 20.7234 3.25333 20.6283 3.72507 20.0531C5.30555 18.1261 8.5 15.4884 14 15.4884V18.997C14 20.9182 16.4468 21.7334 17.6 20.1965L22.4 13.7992C23.2 12.733 23.2 11.267 22.4 10.2008L17.6 3.80353ZM16 5.00302L20.8 11.4003C21.0667 11.7557 21.0667 12.2443 20.8 12.5997L16 18.997V14.5C16 13.9477 15.5523 13.5 15 13.5H14C7 13.5 3.39908 17.4621 3.39908 17.4621C3.81724 16.0361 4.52506 14.4371 5.71707 13.0924C7.28166 11.3273 9.5 10 14 10H15C15.5523 10 16 9.55228 16 9V5.00302Z",
    fill: "#b004ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/forward.0f8e5b582afc054d40bea8fb51b7866a.svg";
export { ForwardRef as ReactComponent };